export const GET_INTERNAL_ACCESS_REQUESTS = "GET_INTERNAL_ACCESS_REQUESTS"
export const RECEIVE_INTERNAL_ACCESS_REQUESTS = "RECEIVE_INTERNAL_ACCESS_REQUESTS"
export const ASSIGN_ACCESS_REQUEST = "ASSIGN_ACCESS_REQUEST"

export const assignAccessRequest = (params, success, error) => ({
  type: ASSIGN_ACCESS_REQUEST,
  params,
  success,
  error,
})

export const getInternalAccessRequests = (success, error) => ({
  type: GET_INTERNAL_ACCESS_REQUESTS,
  success,
  error,
})

export const receiveInternalAccessRequests = (accessRequests) => ({
  type: RECEIVE_INTERNAL_ACCESS_REQUESTS,
  accessRequests,
})
